import React from "react";
import '../custom frames/frame-style.scss'
import useLocalizedNavigate from "../../hooks/useLocalizedNavigate";


const FrameWithButton = ({ style, title, subtitle, buttonTitle, buttonLink }) => {
    const navigate = useLocalizedNavigate();
    const handleLogo = () => {
        if (typeof buttonLink === 'string' && buttonLink.startsWith('/')) {
            navigate(buttonLink);
        } else {
            window.open(buttonLink, '_blank', 'noopener,noreferrer');
        }


    };

    return (
        <div className={style}>
            <div className='title-content'>{title}</div>
            <div className='message-content'>{subtitle}</div>
            <button onClick={handleLogo} className='noBorder'>{buttonTitle}</button>
        </div>
    );
}


export default FrameWithButton;